var _line, _rect, _rect2, _circle, _polygon, _path, _path2, _rect3, _rect4, _rect5, _g, _rect6, _circle2, _rect7, _circle3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _circle4, _path12, _path13, _path14, _path15, _path16, _circle5, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _line2, _path35, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamworkspace4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eVyG4DmXndI1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 720 900",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    "project-id": "562cf4ef97514e34a05d20af7bdecdb7",
    "export-id": "5facc01123d0404cb8664a79d5031bed",
    cached: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 84.5,
    y1: 1019.27,
    x2: 1515.5,
    y2: 1019.27,
    transform: "matrix(7.696982 0 0 7.696982-651-100)",
    fill: "none",
    stroke: "#040404",
    strokeMiterlimit: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 369.25,
    height: 258.62,
    rx: 0,
    ry: 0,
    transform: "translate(169 335.65)",
    fill: "#fff",
    stroke: "#040404",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 186,
    height: 15,
    rx: 7.5,
    ry: 7.5,
    transform: "translate(337.5 419.77)",
    fill: "#ebf1f4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 7.5,
    transform: "translate(318.5 427.27)",
    fill: "#ebf1f4"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "937.41,755.89 944.49,750.27 904.48,749.47 902.14,755.89 937.41,755.89",
    transform: "translate(-770-142)",
    fill: "#fff",
    stroke: "#040404",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M937.8,875.09c-.61,5.26-3.24,10.22-5.11,15.17-3.78,10-4.1,20.29-5.17,30.79-.87,8.61-1.4,17.33-.4,26c1.168879,8.617466,2.997585,17.132484,5.47,25.47s-17.22,1.29-24.39,2.25c-.153424-.028685-.293615-.10579-.4-.22-1.42-1.31-.77-7.88-.74-9.07.087315-5.424407-.247024-10.847399-1-16.22-1.49-11.3-4.56-22.85-4.47-34.29c0-7.25,1.66-14.81,3.41-21.84l1.61-31l8.19-36.24c0,0,9.61-31.11,14.57-41.33.363921-.756236.771268-1.490796,1.22-2.2c4.25,9.31,6.45,33.08,6.45,43.08c0,12.37.53,24.73.75,37.09.07,3.2,0,6.43.15,9.63.03532.978863-.011511,1.958964-.14,2.93Z",
    transform: "translate(-770-142)",
    fill: "#f4f9fd",
    stroke: "#0b2641",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M936.3,875.09c-.62,5.26-3.25,10.22-5.12,15.17-3.78,10-4.1,20.29-5.17,30.79-.87,8.61-1.4,17.33-.4,26c1.173692,8.616624,3.00232,17.131276,5.47,25.47s-14.83,1.11-22.7,2c-1.41-1.31-.76-7.88-.73-9.07.092295-5.424519-.242069-10.847899-1-16.22-1.48-11.3-4.55-22.85-4.47-34.29c0-7.25,1.67-14.81,3.42-21.84l1.61-31l8.19-36.24c0,0,9.6-31.11,14.57-41.33c3.67,10.43,5.57,31.59,5.57,40.88c0,12.37.53,24.73.75,37.09.07,3.2,0,6.43.15,9.63.032087.988819-.014728,1.978623-.14,2.96Z",
    transform: "translate(-770-142)",
    fill: "#741acf"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 21.21,
    height: 21.21,
    rx: 0,
    ry: 0,
    transform: "matrix(.13018-.99149 0.99149 0.13018 560.897 224.345)",
    fill: "none",
    stroke: "#040404",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 173,
    height: 27,
    rx: 0,
    ry: 0,
    transform: "translate(242 513.87)",
    fill: "#f2f36d",
    stroke: "#040404",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 259,
    height: 14,
    rx: 0,
    ry: 0,
    transform: "translate(242 555.87)",
    fill: "#fff",
    stroke: "#040404",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.121038 0 0 1.121038-15.47312-26.771789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1005.13,358.6l-59.65,3.91c-3.35-6.52-8.42-21.86-6.35-52.91l55.16.93v0c.53,10.7,2.71,39.94,10.84,48.07Z",
    transform: "translate(-770-142)",
    fill: "#fec85a"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 935.13,
    y1: 317.61,
    x2: 994.74,
    y2: 317.61,
    transform: "translate(-770-142)",
    fill: "none",
    stroke: "#040404",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.13,358.6l-59.65,3.91-1.35.09c0,0-12-12-9-57l59,1c0,0,0,1.47.16,3.93v0c.53,10.7,2.71,39.94,10.84,48.07Z",
    transform: "translate(-770-142)",
    fill: "none",
    stroke: "#040404",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095.13,356.6l-59.65,3.91c-3.35-6.52-8.42-21.86-6.35-52.91l55.16.93v0c.53,10.7,2.71,39.94,10.84,48.07Z",
    transform: "translate(-770-142)",
    fill: "#12f0e5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1025.13,
    y1: 315.61,
    x2: 1084.74,
    y2: 315.61,
    transform: "translate(-770-142)",
    fill: "none",
    stroke: "#040404",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095.13,356.6l-59.65,3.91-1.35.09c0,0-12-12-9-57l59,1c0,0,0,1.47.16,3.93v0c.53,10.7,2.71,39.94,10.84,48.07Z",
    transform: "translate(-770-142)",
    fill: "none",
    stroke: "#040404",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1190.13,356.6l-59.65,3.91c-3.35-6.52-8.42-21.86-6.35-52.91l55.16.93v0c.53,10.7,2.71,39.94,10.84,48.07Z",
    transform: "translate(-770-142)",
    fill: "#5cc654"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1120.13,
    y1: 315.61,
    x2: 1179.74,
    y2: 315.61,
    transform: "translate(-770-142)",
    fill: "none",
    stroke: "#040404",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1190.13,356.6l-59.65,3.91-1.35.09c0,0-12-12-9-57l59,1c0,0,0,1.47.16,3.93v0c.53,10.7,2.71,39.94,10.84,48.07Z",
    transform: "translate(-770-142)",
    fill: "none",
    stroke: "#040404",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    width: 39.5,
    height: 39.5,
    rx: 0,
    ry: 0,
    transform: "translate(170 240.77)",
    fill: "#fff",
    stroke: "#040404",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "949.42,401.5 954.28,409.1 970.08,395.95",
    transform: "translate(-770-142)",
    fill: "none",
    stroke: "#14b3eb",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 994.5,
    y1: 382.77,
    x2: 1191.5,
    y2: 382.77,
    transform: "translate(-770-142)",
    fill: "none",
    stroke: "#040404",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 994.5,
    y1: 402.77,
    x2: 1161.5,
    y2: 402.77,
    transform: "translate(-770-142)",
    fill: "none",
    stroke: "#040404",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 994.5,
    y1: 422.77,
    x2: 1076.5,
    y2: 422.77,
    transform: "translate(-770-142)",
    fill: "none",
    stroke: "#040404",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1141.5,
    y1: 422.77,
    x2: 1191.5,
    y2: 422.77,
    transform: "translate(-770-142)",
    fill: "none",
    stroke: "#040404",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 186,
    height: 15,
    rx: 7.5,
    ry: 7.5,
    transform: "translate(337.5 365.77)",
    fill: "#ebf1f4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 7.5,
    transform: "translate(318.5 373.27)",
    fill: "#ebf1f4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 186,
    height: 15,
    rx: 7.5,
    ry: 7.5,
    transform: "translate(337.5 392.77)",
    fill: "#ebf1f4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 7.5,
    transform: "translate(318.5 400.27)",
    fill: "#ebf1f4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M939.35,629.54c0,0,7.27-1.54,8-2s7.15-8.32,11.06-16.68s8.59-19.47,8.59-21.34-1.7-11.56-4-18.28-3.53-7-2.92-10.18s2.48-9.08,3.85-9c.733788-.039417,1.378005.483738,1.49,1.21s-.17-3.41,1.32-3.9s2,.27,2,1.21c0,0,0-.44.66,0s-1.71,4.68-1.6,7.32c0,0,.33.55.83-.22s.6-2.86,2.14-2.48-.38,3.8-.71,5c-.342738,2.872703.106817,5.784434,1.3,8.42c1.5,3.24,2.77,8.25,4.81,11s2.86,5.45,2.09,7.16c-.723552,2.139167-1.203257,4.353191-1.43,6.6c0,.5-1.82,14.26-1.82,14.26l-2.64,12c0,0-6.61,15.52-7.32,16.07-9.021329.960408-18.097944-1.218686-25.7-6.17Z",
    transform: "translate(-770-142)",
    fill: "#fff",
    stroke: "#040404",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M966.21,591.07c0,0,1.32-4.29.88-6.88s-.44-6.22,1.77-6.44s3.08.77,3.13,2-.38,4.35,1.71,6.11s3.84,6.35,4.32,8.48",
    transform: "translate(-770-142)",
    fill: "#fff",
    stroke: "#040404",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M996.67,569.84c1.36,0,3.13.2,3.4,1c.44,1.26-.39,4.29-.83,5.67s-4.35,6.22-4.51,9.91-.28,5.51-.28,5.51",
    transform: "translate(-770-142)",
    fill: "#fff",
    stroke: "#040404",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M948.25,1001.28c.541957.367611,1.117928.682386,1.72.94.633774.15857,1.287504.222595,1.94.19c2.39,0,4.79.14,7.17.36c3,.28,5.62.82,7.4,3.39c1,1.45,2.74,4.21,1.7,6-.501849.736674-1.165406,1.348925-1.94,1.79-5.88,3.87-11.61,5.75-18.58,5.17-2.918524-.225487-5.81439-.683609-8.66-1.37-2.035452-.421688-3.955869-1.277859-5.63-2.51-2.73-2-7.24-4.06-10.71-4.06-1,0-1.76,3.19-2.12,4.47s-10.34-.48-15-.48-3.19-6.63-3.3-9.66l3-12c2.16-8.06,1.12-25.55,1.12-25.55c4.55,1.83,22.47,1.74,24.55,1.66c1.57-.06,1.94,1.65,2.26,2.85.01-.01,2.46,21.78,15.08,28.81Z",
    transform: "translate(-770-142)",
    fill: "#0b2641"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M937.69,756c0,0-5,27.9-8.43,36.66-3.751835,9.611632-6.532357,19.574609-8.3,29.74-1.827102,10.553024-4.254374,20.993298-7.27,31.27-1.17295,4.598853-2.666606,9.109894-4.47,13.5l-4.11,9.38-2.11,4.67c-.48,1.11-1.88,3.12-1.88,4.31-1.435421,3.55794-3.196226,6.975775-5.26,10.21-2.91,4.29-7.11,6.92-11.2,9.91-3.55,2.61-7.34,4.92-10.8,7.63-3.13,2.42-27.46,28.25-33.33,34.7s-12.45,18.34-12.45,18.34l-1.76.45c-.359208-.060669-.713489-.147568-1.06-.26-7.2-2.19-10.89-12.89-10.53-15.29.46-3,17.76-31.37,24.22-41.4c3.159845-4.637991,6.851622-8.890247,11-12.67c3.82-3.68,8.54-6.38,12-10.5c2.046918-2.595672,3.704358-5.47598,4.92-8.55c3.87-9.17,4.85-18.78,6.38-28.5c1-6.33,2.08-12.71,2.58-19.11.483863-6.279764-.406807-12.589534-2.61-18.49-10.37-17.77-7.83-29.16-3.8-36.77c3.12-5.89,10.58-24.55,12.46-28.35.1-.2.18-.35.25-.47c15.13,4.06,55.56,9.59,55.56,9.59Z",
    transform: "translate(-770-142)",
    fill: "#f4f9fd",
    stroke: "#0b2641",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M936,756c0,0-5,27.9-8.43,36.66-3.751835,9.611632-6.532357,19.574609-8.3,29.74-1.827474,10.549657-4.254743,20.986581-7.27,31.26-1.17295,4.598853-2.666606,9.109894-4.47,13.5l-4.11,9.38c-.7,1.56-1.38,3.12-2.07,4.68-.48,1.11-1.88,3.12-1.88,4.31-1.435421,3.55794-3.196226,6.975775-5.26,10.21-2.91,4.29-7.11,6.92-11.2,9.91-3.55,2.61-7.34,4.92-10.81,7.63-3.12,2.42-27.45,28.25-33.32,34.7s-12.46,18.34-12.46,18.34l-.72.19c-7.19-2.19-10.89-12.89-10.52-15.29.46-3,17.75-31.37,24.21-41.4c3.165737-4.633448,6.856947-8.885051,11-12.67c3.82-3.68,8.55-6.38,12-10.5c2.050983-2.592919,3.708781-5.473849,4.92-8.55c3.88-9.17,4.85-18.78,6.38-28.5c1-6.33,2.09-12.71,2.59-19.11.47111-6.282685-.433224-12.592545-2.65-18.49-10.38-17.77-7.84-29.16-3.8-36.77c3.12-5.89,10.58-24.55,12.45-28.35C898.61,750.89,936,756,936,756Z",
    transform: "translate(-770-142)",
    fill: "#7d17e5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M786.62,984.46c-.027289,5.279984.306825,10.555644,1,15.79.41,3,.81,6.63,2.44,9.32c4.301609,6.462138,11.722565,10.140218,19.47,9.65.73,0,6.29-.12,7.32-1.7c2-3-1.52-9.08-5.74-13.17-.480933-.388294-.830186-.915666-1-1.51-.047301-.488505.031906-.980964.23-1.43q2-6,4.26-11.88c1.43-3.77,2.61-8.89,5-12.16c1.44-2,4-3.65,5.81-5.29c1.14-1,3.9-2.78,4.27-4.39.31-1.32-.38-3.33-4.5-3s-6.7-7.92-8.92-17.43c-2.410085,2.391924-4.950632,4.648704-7.61,6.76-4.79,3.83-9.52,5.78-15.19,8l-7.22,3.27c-1.48.41-8.17,5.38-8.17,7c0,.93,4,13.59,4,13.59l4.55-1.42Z",
    transform: "translate(-770-142)",
    fill: "#0b2641"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M942.1,751.24c-1.88.22-52.88,2.36-60-4.8c0,0,16.51-27.45,10.23-41.76s-14.2-33.58-14.2-33.58-7.38-17-4.94-25.05c0,0,1.33,11.53,8,12.06c5.62.44,8.37-8.26,13.87-15.64s11.78-15.74,19.27-13.21c0,0-9,4.3-10.68,10.24s-7.93,16.73.88,21s21.36,8.7,28.07-2.2l16.74,1.32c0,0,4.51,8.58-.66,17s-5.62,9.58-5.62,9.58l7,64.13-7.96.91Z",
    transform: "translate(-770-142)",
    fill: "#fce75e"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M878.2,613.85c0,0,2.64,5.45,1.81,9.63s-2.86,12.83-5.5,14.87c0,0-1.78,7-1.69,11.47s5.09,8.46,7.59,8.23s4.76-.51,7.71-5.29s11.32-18.33,15.87-20.93s5.51-3,5.51-3c.449394-1.951432.057447-4.001893-1.08-5.65-1.93-2.86.16-12.44,1.26-13.81s5.9-5.19,7.6-5.63c0,0-13.82.72-19-4.64c0,0-4.08,1.18-6.39-.58s-5.56-4.13-5.12-7.65c0,0-4.95,3.36-4.73,5.67s9.53,16.37-3.84,17.31Z",
    transform: "translate(-770-142)",
    fill: "#fff",
    stroke: "#040404",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M869.85,760.22c70.5-44.2-7.4-95.12,3-112.72c14.81-25.16,12.52-46.22,12.52-46.22l17.59-27.66l5.26.52l4.3.43v0c.18-.92,4.26-21.26-17.54-29.26-17.77-6.52-44.73,6.51-52.09,38.47-4.87,21.14,8.52,25.13,4.69,30.75-9.78,14.38-9.92,24.5-6.17,38.63s-10.68,13.51-17.1,38.47c-.02-.03-39.54,121.93,45.54,68.59Z",
    transform: "translate(-770-142)",
    fill: "#040404"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M895.76,560.84c0,0,9.9,2.92,13,9.85c1.54,3.42,9.8,8.54,9.8,8.54s4.68,16.73,3.19,20.91-9.25,4.41-9.25,4.41-13.54-2.2-14.36-3.31-3.19-.86-5.22-2.17-6.34-3.88-6.18-8.23s4.41-3.47,5.45-3.19s3.58-6.28,3.14-9-7.43-14.15-.88-18.38l1.31.57Z",
    transform: "translate(-770-142)",
    fill: "#fff",
    stroke: "#040404",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 3.08,
    transform: "translate(77.91 470.19)",
    fill: "#12f0e5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M847.51,614.76c-1.34,2.65-4.2,4.22-5.72,6.77-1.182085,2.321505-1.625269,4.949207-1.27,7.53.367083,2.564975.580796,5.149567.64,7.74-.120464,1.751409-.381302,3.490326-.78,5.2",
    transform: "translate(-770-142)",
    fill: "none",
    stroke: "#12f0e5",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M848.22,611.46c-.09,3-2,5.6-2.29,8.56-.081979,2.603118.637073,5.168666,2.06,7.35c1.421702,2.166838,2.717189,4.413906,3.88,6.73.6367,1.623443,1.141665,3.295511,1.51,5",
    transform: "translate(-770-142)",
    fill: "none",
    stroke: "#12f0e5",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1050.5,517.52v49c0,5.522847-4.477153,10-10,10h-66c-5.522847,0-10-4.477153-10-10v-49c0-5.522847,4.477153-10,10-10h66c3.93859.002105,7.509117,2.315901,9.12,5.91.584008,1.284198.884166,2.679251.88,4.09Z",
    transform: "translate(-770-142)",
    fill: "#ebf1f4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1047.5,519.3v45.44c-.011029,5.128436-4.171552,9.280012-9.3,9.28h-61.4c-5.128448.000012-9.288971-4.151564-9.3-9.28v-45.44c.011029-5.128436,4.171552-9.280012,9.3-9.28h61.4c3.658487-.000297,6.977266,2.144386,8.48,5.48.544158,1.192715.823888,2.489022.82,3.8Z",
    transform: "translate(-770-142)",
    fill: "#ebf1f4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1047.5,537.43v27.31c-.011029,5.128436-4.171552,9.280012-9.3,9.28h-61.4c-5.128448.000012-9.288971-4.151564-9.3-9.28v-6.35l17-14.62l15,16l40-31l8,8.66Z",
    transform: "translate(-770-142)",
    fill: "#ff5294"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    r: 6,
    transform: "translate(213 379.27)",
    fill: "#ff5294"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M996.82,562.88c0,0-2.31-.44-2.26-2.26s.94-1.43,2-1.21c1.919401.660923,3.488908,2.071675,4.35,3.91.88,2.14.66-.69.22-2.05-.637031-2.140624-1.682992-4.137459-3.08-5.88-1.82-2.2.83-3.69,1.82-3s5.23,6.66,5.28,8.64l.77.06c0,0,.66-4.41,0-6.22s-1.21-5.65,1.38-5.72c.590011.504058.95076,1.225556,1,2c.06,1.21,1.54,7.93,1.66,10.19s-2.37,6.88-3.36,8.58-5.45,8.32-9,11.56-4.29,6.72-4.24,8.64s1.21,18.61,1.93,21.47s2.47,10.63,2.53,12.22.55,16.9.17,19-1.55,9.42-3.53,10.08-10.24,3.58-12.82,4.07-11.62,3.3-19.43,2.92-16.94-.52-16.94-.52l-13-1c-2.025048,4.121982-6.207521,6.743773-10.8,6.77-7.8,0-22.27-4.39-21.75-10.37s3-15.19,5-18.18s6.31-6.46,9.23-7.29c0,0,.44.68,3.08-.46s18.44-1,22.29.74s10.46,8,25.71,6.05c0,0,9.14,1.71,13.76,1.32.738062-2.655782,1.253183-5.368531,1.54-8.11.22-3.39,1.43-16.11,1.43-16.11s1-8.59,1.05-13.62.16-16.49.55-17.26s2.92-5.45,5.39-6.93c2.211301-1.147812,3.847862-3.160926,4.52-5.56.63-2.35,2.61-6.25,3.55-6.47Z",
    transform: "translate(-770-142)",
    fill: "#fff",
    stroke: "#040404",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M878.88,731.44c0,0,19.57,14.08,70.2,9.16",
    transform: "translate(-770-142)",
    fill: "none",
    stroke: "#040404",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M943.11,686.18c0,0-7,1.43-17.8-2.31",
    transform: "translate(-770-142)",
    fill: "none",
    stroke: "#040404",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1266.55,621.76c0,0-5,5.32-5.83,10.2s-4.19,9.94-6.28,9.39-28-6.82-39.19-12.11-16.51-7.7-17.39-11-2.87-6.5-8.48-6.28c0,0-2.09-2.75-3.74-2.64s-3.2,1.65-3.2,2.31-.55.33-3.63-1.87-6.55-4.79-8.75-8-6.94-9.9-9.86-7.09c0,0-.55.4-.93-.41s-3.08-3.56-5-1.52s2.92,6.11,2.92,6.11-1.32,1.27-.44,2.26s5.45,8.47,7.71,10.84s7.59,7.93,9.69,9.25s16,9.07,17.94,10.75c1.220596,1.030418,2.620647,1.827057,4.13,2.35l20.15,14.26l14.31,8.69c0,0,24.93,11.84,26.14,12.06c1.271212.242087,2.586626.066699,3.75-.5.82-.55,17.34-15.63,17.34-15.63l15.3-19.23c0,0-6.33-.81-8.37-1.19s-16.47-7.7-18.29-11Z",
    transform: "translate(-730-142)",
    fill: "#fff",
    stroke: "#040404",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1346.09,972.4c0,0,4.13,14.61,4.13,16.84s.66,10.41.66,12.14s2.81,5.7-4.79,7-9.82,0-10.57-.41-2.88,3-3,3.3c-1.284874,2.62473-3.627083,4.577783-6.44,5.37-4.751162,1.239298-9.623284,1.956871-14.53,2.14-3.88,0-14.28-2.34-16-2.78s-3-1.43-2.31-2.67c.970389-1.22544,1.623052-2.671606,1.9-4.21.33-2.14,5.12-6.93,5.12-6.93s5.37-3.22,8-7s10.07-15,11.39-18.17l1.32-3.22l25.12-1.4Z",
    transform: "translate(-730-142)",
    fill: "#0b2641"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1386.39,965.22c0,0,.08,4,0,5.12s-1.08,4.12-.58,6.11s1.81,9.24.61,13.29c-.81,2.74-.86,10.74-.82,15.59.04021,2.655187-1.324777,5.134216-3.59,6.52-4.576318,2.842999-9.884189,4.285544-15.27,4.15-11-.5-14.7-1.82-14.7-3.72s.77-3.65,1.11-5.47c.48-2.64-.08-5.69,1.24-8.12c1.318875-2.102681,2.427555-4.330088,3.31-6.65.591274-1.934998,1.058885-3.905642,1.4-5.9.32-1.75.8-3.48,1.18-5.23.824483-3.279412,1.353266-6.626144,1.58-10c.2-5.5-.36-6-.36-6s15.42,8.54,24.89.31Z",
    transform: "translate(-730-142)",
    fill: "#0b2641"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1388,957.87c.33,3.41.77,6.49-.55,8.25s-5.06,4.08-12.66,3.2-14-3.42-14-5.84s2.2-9.25,1.87-12.33l-22.13-144.88c0,0-.77.22-.88,2.09s1.32,17.51,1.32,17.51l1,45.36l5.39,101.06c0,1.54-1.54,1.87-3.52,1.76s-22.57.48-24.44,0L1307,865.17l-3.53-13.54c0,0-5-23.12-6.6-31.38s-5.51-32.25-5.51-32.25-1.92-21-1.87-28c.1-14.82,4.77-59.08,4.77-59.08s16.92,7,32.11,7.89s40,.55,58.57-5.28c0,0,3.08,4.73,2.31,8.36s-1.76,5.51-1.54,7.38s1.67,17.06,1.67,17.06s2.07,19.71,1.74,24.55-1.1,15.64-1.54,21.25-1.1,13-1,18.5-.44,19.92-.44,20.47-.88,17.51.44,21.91.44,11.12-1.65,13.65-1.32,4.08,0,6.17s3.71,13.76,4.22,16.18c1.117666,4.682603,1.455532,9.51746,1,14.31-.56,8.15-1,38.1-1,38.1L1388,957.87Z",
    transform: "translate(-730-142)",
    fill: "#fff",
    stroke: "#040404",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1308.36,498.13c0,0-4.71,14.45-3.8,24.27s3.71,16.77,13.7,16.6l3.12,14.23c0,0-10,38,10.35,24.42c5.41-3.62,22.59-23.46,22.51-26s-11.37-26.34-11.37-26.34l-2.23-19.4-5.86-8.67-28.07-3.63l1.65,4.52Z",
    transform: "translate(-730-142)",
    fill: "#fff",
    stroke: "#040404",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1330.68,507.79l-3.53,4.4h-1.54v-8.8c0,0-13,1.32-17.61-2.87s-12.33-10.35-9.69-15s6.39-1.1,7-2.42-1.1-9,3.52-9.69s9-.44,10.79-3.3s7,4.84,11,5.94s23.78,7.05,23.56,20-7.49,32.15-11,34.35-6.73-6.21-8.15-9.47c-1.315053-2.613238-.802789-5.775558,1.27-7.84s2.23-4.38.16-6-5.78.7-5.78.7Z",
    transform: "translate(-730-142)",
    fill: "#040404"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1409.1,616.62c1.773602,6.183953,4.01335,12.224587,6.7,18.07c1.67,3.41-26-13.81-26-13.81s-.72-4.68.71-5.23s8.68-5.47,18.59.97Z",
    transform: "translate(-730-142)",
    fill: "#fff",
    stroke: "#040404",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1410.58,620.28c0,0-7.07-.07-11.26,1.36s-9.69,19.6-11.23,23.45-2.86,13.76-3.57,18.55-.83,16.79,0,19c1.344776,4.689692,1.991714,9.551835,1.92,14.43-.11,5.72,2.52,15,.85,12.84-6.13-7.78-45.65,5.65-72.08.59-8.89-1.71-19.15-7.27-20.36-8.59-.680363-.708475-1.01208-1.681857-.905938-2.658363s.639246-1.855886,1.455938-2.401637c2-1.66.66-3.42-.22-5.07s1-3.08.55-4.29-.22-1.54,1.87-3.41s1.1-7.16,1.65-11.23-1.32-4.41-2.42-7.71.44-3.41,2-5.62.22-2.86-.66-6.49.77-8.26-.66-10.57c-1.059506-1.626938-1.525699-3.569413-1.32-5.5c0-1.88-.31-2.64-1.3-3.19s-4.65,5-4.65,5L1264,624.51c0,0,1.81-3.86,3.13-5.18s7.27-12.11,8.59-14-.11-2.75,2.42-4.73s8.48-16.85,10.13-18.7s4.29-5.63,6-5.52s3.41-.22,6.38-1.63s5.4-.14,8.92-3.33c2.94-2.67,4.42-3,4.83-3h.11c-.08,0-.61-.09-1.42-2.42-.88-2.53.55-8,2.86-12.11s5.18-1.32,5.18-.88-1.65,9.13-2,10.57s1.32,3.63,3.41,5.39c.365901.314316.650614.712229.83,1.16.416333,1.348483.474916,2.782043.17,4.16v0c-.07264.328601-.112833.663542-.12,1c.119757.360389.369263.66336.7.85.82-1.88-.71-10.13-.71-11.34s5.06-4,5.06-4s21.47-16.51,22.35-17.94c.76-1.24-.87-1.32-1.32-1.32c7.38-.27,7.38,5.84,7.49,6.93s1.43,3.2,1.65,4.63c.017871.069638.056182.13233.11.18c1.54,1.69,19.73,7.27,20.37,9.39s4.51,1.77,8.58,3.64s6.72,8.14,10.13,13.1s5.07,13.21,5.18,16.18s4,9.69,4.73,12.55s2.84,12.14,2.84,12.14Z",
    transform: "translate(-730-142)",
    fill: "#7ee8fe"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1377.14,599.6c0,0-.5-3.05,0-3.55c1.499544-1.216985,2.403021-3.020295,2.48-4.95.24-3.22,2.31-5.62.82-8.18s-4.62-1.4-6.27.75-3.06,7.51-3.14,9.41-3.55,8.5-4,10.16c0,0-6.61,3-6.53,6.11s1.32,4.12,1.32,4.12-2.23,2.81-1,5c.564027,1.200354,1.529646,2.165973,2.73,2.73s-.91,6.11,2.48,6.68c0,0,.24,4.27,2.47,5.15s6.77,1.13,8.42,1.62s2.15.42,2.73,1s7.43,10.08,8.5,13.13c.985132,2.68129,2.670128,5.049953,4.88,6.86c1.48,1.07,5.69,4.29,7.76,4.79s4.62,1.65,8.5,2.8c2.376314.84062,5.017532.406706,7-1.15.41-.5,4.79-8.34,4.71-11.23s-4.79-16.35-6-17.42c-3.353304-2.447545-6.960837-4.526236-10.76-6.2-3.53-1.37-11.36-8-13.5-9.25s-6.1-4.56-6.7-4.73-1.11-3.47-1.33-4.35-3.53-8.5-5.57-9.3Z",
    transform: "translate(-730-142)",
    fill: "#fff",
    stroke: "#040404",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1297.77,697.39c0,0,23.17,9.47,37,9.47s33.25-8.15,47.78-7.27",
    transform: "translate(-730-142)",
    fill: "none",
    stroke: "#040404",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1323.31,570.18c.416333,1.348483.474916,2.782043.17,4.16l-.17-4.16Z",
    transform: "translate(-730-142)",
    fill: "#040404"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1324.07,576.29c.82-1.88-.71-10.13-.71-11.34s5.06-4,5.06-4s21.47-16.51,22.35-17.94c.76-1.24-.87-1.32-1.32-1.32c7.38-.27,7.38,5.84,7.49,6.93s1.43,3.2,1.65,4.63c.017871.069638.056182.13233.11.18l-34.63,22.86Z",
    transform: "translate(-730-142)",
    fill: "#040404"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1323.48,574.34v0c-.07264.328601-.112833.663542-.12,1-1.54-1-8.27-6.31-8.27-6.31l-.78-.66h.11c-.08,0-.61-.09-1.42-2.42-.88-2.53.55-8,2.86-12.11s5.18-1.32,5.18-.88-1.65,9.13-2,10.57s1.32,3.63,3.41,5.39c.365901.314316.650614.712229.83,1.16.444074,1.376991.51311,2.84746.2,4.26Z",
    transform: "translate(-730-142)",
    fill: "#040404"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1410.48,620.28c0,0-11.21-.24-12.71,2.54c0,0,4.12-1.1,5.52-1.27c1.81-.22,7.29-.13,7.29-.13l-.1-1.14Z",
    transform: "translate(-730-142)",
    fill: "#040404"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1409.67,616.93c0,0-9.74-1.58-15.22,3.23",
    transform: "translate(-730-142)",
    fill: "none",
    stroke: "#040404",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1294.87,
    y1: 633.76,
    x2: 1298.7,
    y2: 610.25,
    transform: "translate(-730-142)",
    fill: "none",
    stroke: "#040404",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1266.42,620.16c0,0,22,9.79,25.71,15.93",
    transform: "translate(-730-142)",
    fill: "none",
    stroke: "#040404",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.625978 0 0 0.625974 8.219603-31.117086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#edf1fc"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 7.37,
    transform: "translate(1035.94 43.09)",
    fill: "#fce75e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.601694,619.96898v23c0,6.627417-5.372583,12-12,12h-9.5l3.26,15.4-13.15-11.4h-3.39l-4.61-4h-57.61c-.33,0-.65,0-1,0-1.947618-2.2083-3.015351-5.055587-3-8v-23c0-6.627417,5.372583-12,12-12h85c.33,0,.65,0,1,0c1.947618,2.2083,3.015351,5.055587,3,8Z",
    transform: "translate(200 0)",
    fill: "#fed56b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.601694,625.28898v-5.32c0-6.627417,5.372583-12,12-12h13.05",
    transform: "translate(200 0)",
    fill: "none",
    stroke: "#040404",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.601694,607.96898h57c6.627417,0,12,5.372583,12,12v23c0,6.627417-5.372583,12-12,12h-9.5l3.26,15.4.76,3.6-17.3-15-4.61-4h-57.61c-.33,0-.65,0-1,0-6.234036-.521278-11.021756-5.744245-11-12v-6.89",
    transform: "translate(200 0)",
    fill: "none",
    stroke: "#040404",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 529.601694,
    y1: 637.96898,
    x2: 610.601694,
    y2: 637.96898,
    transform: "translate(200 0)",
    fill: "none",
    stroke: "#3f3f3f",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 529.601694,
    y1: 626.96898,
    x2: 560.601694,
    y2: 626.96898,
    transform: "translate(200 0)",
    fill: "none",
    stroke: "#3f3f3f",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 579.601694,
    y1: 626.96898,
    x2: 610.601694,
    y2: 626.96898,
    transform: "translate(200 0)",
    fill: "none",
    stroke: "#3f3f3f",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.867781,452.790127c2.461073-.472313,4.853112-1.251741,7.12-2.32",
    transform: "matrix(.94936-.358318 0.458536 1.214888-49.393809 127.427325)",
    fill: "none",
    stroke: "#040404",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.44185,445.976594c4.244866-3.242432,8.254888-6.781275,12-10.59c30.15-29.75,49.83-70.3,65.38-109.25c14.22-35.59,26.28-72.23,44.63-105.89c13.55-24.85,30.87-48.22,53.2-65.86c14.77-11.67,51.22-37.86,68.21-16.59c11.85,14.83,8.69,47.19-2.65,61.33-5.82,7.26-14.67,11.74-23.85,13.28-11.56,1.93-32.79,1.48-35-13.59-2.11-14.25,16.44-27.84,26.3-34.68c15.79-11,34.52-19.64,53.64-22.42c16.86-2.44,34.73,0,49.32,8.76c11,6.6,20.51,17.59,24.56,30.09",
    transform: "matrix(.769271-.214335 0.348526 1.250895 159.306513 110.599343)",
    fill: "none",
    stroke: "#040404",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "15.12,10.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.9,149.41c.501594,2.452457.76946,4.94696.8,7.45",
    fill: "none",
    stroke: "#040404",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.920152-.391562 0.391562 0.920152-152.518292 346.80493)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "608.645396,441.629468 664.085396,440.459468 643.605396,427.899468 643.695396,427.059468 640.365396,425.019468 642.715396,402.989468 608.645396,441.629468",
    transform: "matrix(.935579-.353116 0.353116 0.935579 46.028574 381.788505)",
    fill: "#40764d"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "602.745396,441.749468 608.645396,441.629468 664.085396,440.459468 665.505396,440.429468 643.695396,427.059468 640.365396,425.019468 642.715396,402.989468 643.505396,395.529468 602.745396,441.749468",
    transform: "matrix(.935579-.353116 0.353116 0.935579 47.180207 380.761094)",
    fill: "none",
    stroke: "#3f3f3f",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamworkspace4);
export default __webpack_public_path__ + "static/media/Team workspace4.fef2dfd98c9a00db5930103c00578b67.svg";
export { ForwardRef as ReactComponent };